import ApolloClient from "apollo-boost";
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";

import { getToken } from "./auth";
import { getUrl } from "./api";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [], // no types provided
    },
  },
});

const Client = new ApolloClient({
  uri: `${getUrl()}/graphql`,
  request: async (operation) => {
    operation.setContext({
      headers: {
        authorization: `Bearer ${getToken()}`,
      },
    });
  },

  onError: () => {
    // console.log('acho que deu merda!')
  },

  cache: new InMemoryCache({
    fragmentMatcher,
    resultCaching: false,
  }),
});

export default Client;
